/**
 * UnsavedChangesModal — shared guard modal for unsaved form changes.
 *
 * Three actions:
 *   onSave  — save changes and continue (navigate away)
 *   onLeave — discard changes and continue (navigate away without saving)
 *   onStay  — cancel and stay on the current page / tab
 *
 * z-[70] so it sits above portal modals (z-50) and drilldown modals (z-50).
 */

import React from 'react';

const UnsavedChangesModal = ({ onSave, onLeave, onStay, saving = false }) => (
  <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-60 px-4">
    <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6">
      <h3 className="text-base font-semibold text-neutral-800 mb-1">Unsaved Changes</h3>
      <p className="text-sm text-neutral-500 mb-5 leading-relaxed">
        You have unsaved changes that will be lost if you leave without saving.
      </p>
      <div className="space-y-2">
        <button
          onClick={onSave}
          disabled={saving}
          className="w-full py-2.5 text-sm font-semibold bg-neutral-900 text-white rounded-xl hover:bg-neutral-700 disabled:opacity-50 transition-colors"
        >
          {saving ? 'Saving…' : 'Save & Continue'}
        </button>
        <button
          onClick={onLeave}
          disabled={saving}
          className="w-full py-2.5 text-sm font-semibold bg-red-50 text-red-600 border border-red-200 rounded-xl hover:bg-red-100 disabled:opacity-50 transition-colors"
        >
          Leave Without Saving
        </button>
        <button
          onClick={onStay}
          disabled={saving}
          className="w-full py-2.5 text-sm text-neutral-500 hover:text-neutral-800 border border-neutral-200 rounded-xl transition-colors"
        >
          Stay on This Page
        </button>
      </div>
    </div>
  </div>
);

export default UnsavedChangesModal;
